import { getHomeApiUrl } from '../selectors/getBaseUrlSelectors';
import CLIENT_ID_ONLINE from '../constants/rootConstants';

export default {
  fetch: (id, action, state) => ({
    url: `${getHomeApiUrl(state)}/travel/home/v1/unusedCredit`,
    opts: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        clientId: CLIENT_ID_ONLINE,
      },
    },
  }),
  transformData: (data) => data.map((obj) => ({ ...obj, id: obj.accountToken })),
};
